<h2 class="bd-title">Security Role Filter</h2>
@if (errorMessage) {
<alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
  <coso-alert-message>
    <div class="d-inline" [innerHTML]="errorMessage"></div>
  </coso-alert-message>
</alert>
}

<form #settingsForm="ngForm" id="settingsForm">
  @if (settings$ | async; as settings) {
  <div class="cs-row">
    <div class="cs-label-wrapper">
      <label id="roleFilterModeLabel" for="roleFilterMode" class="cs-larger-text cs-bolder-text">Security role filter mode</label>
      <div id="roleFilterModeSubLabel" class="cs-secondary-text">
        Select how you want to filter Dynamics 365 security roles.
        <ul>
          <li>None: No filter is applied. All roles are replicated.</li>
          <li>Include: Only the selected roles will be replicated.</li>
          <li>Exclude: The selected roles will be excluded from replication.</li>
        </ul>
      </div>
    </div>
    <div class="cs-input-wrapper">
      <select
        class="form-control"
        id="roleFilterMode"
        aria-describedby="roleFilterModeSubLabel"
        name="roleFilterMode"
        [(ngModel)]="settings.roleFilterConfiguration.mode"
        (ngModelChange)="updateSettings(settings)"
        [disabled]="readonly$ | async"
      >
        <option [ngValue]="RoleFilterMode.NONE">None</option>
        <option [ngValue]="RoleFilterMode.INCLUDE">Include</option>
        <option [ngValue]="RoleFilterMode.EXCLUDE">Exclude</option>
      </select>
    </div>
  </div>
  @if (settings.roleFilterConfiguration.mode !== RoleFilterMode.NONE) {
  <div>
    <div class="cs-secondary-text">
      Select which Dynamics 365 security roles are going to be {{ settings.roleFilterConfiguration.mode === RoleFilterMode.INCLUDE ? "replicated" : "excluded from replication" }}.
    </div>
    <div class="cs-padded-left-wrapper">
      @for (role of securityRoles; track role) {
      <div class="custom-control custom-checkbox">
        <input
          role="checkbox"
          type="checkbox"
          class="custom-control-input"
          id="{{ role.name }}"
          name="{{ role.name }}"
          [attr.aria-checked]="inputChecked(settings, role)"
          [checked]="inputChecked(settings, role)"
          (change)="inputChanged(settings, role)"
          [disabled]="readonly$ | async"
        />
        <label class="custom-control-label" for="{{ role.name }}">{{ role.name }}</label>
      </div>
      }
    </div>
  </div>
  } }
</form>
